export const keywordOverviewCss = {
  card: {
    marginTop: '1rem',
    width: 'Hug (1,140px)',
    height: 'Hug (529.87px)',
    gap: '16px',
    backgroundColor: '#FFFFFF',
    boxShadow: '0px 0px 12px 2px rgba(0,0,0,0.06)',
    padding: '24px',
    borderRadius: '8px',
    marginBottom: '1rem'
  },
  cardContent: {
    padding: 0
  },
  keywordOverview: {
    fontSize: 'var(--font-size-30)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-38)',
    textAlign: 'left',
    color: 'var(--color-primary)'
  },
  mainContainer: {
    display: { xs: 'grid', md: 'flex' },
    alignItems: 'end',
    gap: 4,
    marginTop: 4
  },
  boxOne: {
    flexGrow: 1,
    minHeight: '89px'
  },
  keywordInputLabel: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left'
  },
  keywordInput: {
    height: '100%',
    gap: '8px',
    borderRadius: '6px',
    border: '1px',
    opacity: '0px',
    padding: '15px'
  },
  keywordInputSx: {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'var(--color-text-tertiary)',
      borderRadius: '6px',
      height: '3rem'
    }, // Initial border color
    '& .MuiOutlinedInput-root:not(.Mui-disabled):hover .MuiOutlinedInput-notchedOutline': {
      borderColor: 'var(--color-purple-deep-alt)'
    }, // Border color on hover
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: 'var(--color-purple-deep-alt)'
    } // Border color on focus
  },
  autoComplete: {
    padding: '0px'
  },
  autoCompleteInput: {
    height: '44px',
    paddingTop: '3px',
    Padding: '0px',
    paddingRight: '14px'
  },
  menuitemBox: {
    display: 'flex',
    alignItems: 'center'
  },
  img: {
    marginRight: '10px',
    width: 20
  },
  searchBtn: {
    width: '12%',
    padding: '10px 18px 10px 18px',
    gap: '8px',
    borderRadius: '8px',
    border: '1px',
    opacity: '0px',
    marginBottom: '26px'
  },
  toggleBtn: {
    ml: 2,
    mb: '26px',
    height: '45px',
    '& .MuiToggleButton-root': {
      fontSize: 'var(--font-size-14)',
      color: '#2D2D2D',
      fontWeight: 500,
      textTransform: 'none',
      borderColor: 'var(--color-border-light2)',
      borderRadius: '8px',
      paddingX: 2, // horizontal padding
      '&.Mui-selected': {
        backgroundColor: 'var(--color-purple-ultra-dark) !important',
        color: 'var(--color-white) !important',
        height: '45px'
      },
      '&.Mui-selected:hover': {
        backgroundColor: 'var(--color-purple-ultra-dark) !important',
        height: '45px'
      }
    }
  },
  exampleText: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-primary)'
  },
  exampleTextSpan: {
    color: 'var(--color-text-tertiary)'
  },
  loaderBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    mt: 5,
    backgroundColor: 'white',
    borderRadius: '8px',
    padding: '25px'
  },
  cardSkeleton: {
    borderRadius: '100px',
    marginTop: '8px',
    marginBottom: '8px',
    padding: '5px'
  },
  breadcrumbsMainBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  breadcrumbsMainBoxNew: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '-32px',
    paddingTop: '32px'
  },
  userTutorial: {
    //styleName: Text md/Bold;

    fontSize: 'var(--font-size-16)',
    // fontWeight: 700,
    lineHeight: 'var(--line-height-24)',
    textAlign: 'left',
    color: 'var(--color-purple-deep-alt)',
    cursor: 'pointer'
  },
  userTutorialBox: {
    display: 'flex',
    gap: '8px',
    '&:hover': {
      cursor: 'pointer' // Change cursor to pointer on hover
    }
  },
  getStartedToolTipText: {
    color: 'var(--color-primary)',
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-15)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left'
  },
  getStartedToolTipTextHead: {
    //color: 'var(--color-primary)',
    fontWeight: 700
  },
  imgInfo: {
    maxWidth: '100%', // Make the image responsive
    height: 'auto',
    backgroundSize: 'cover'
  },
  imgInfoBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%', // Ensure the box takes up the full width
    height: 'auto', // Adjust height if necessary
    textAlign: 'center', // Center align the text within the box,
    padding: '2rem'
  },
  linkStyle: {
    textDecoration: 'underline',
    cursor: 'pointer'
  },
  analyzePreviousBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  previousSearchesBtn: {
    gap: '6px',
    paddingTop: '10px',
    paddingRight: '16px',
    paddingBottom: '10px',
    paddingLeft: '16px',
    borderRadius: '6px',
    maxHeight: '40px'
  },
  previousSearchesText: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '20px',
    color: '#120242'
  },
  updateBtnSx: {
    gap: '6px',
    borderRadius: '6px',
    paddingTop: '10px',
    paddingRight: '16px',
    paddingBottom: '10px',
    paddingLeft: '16px',
    border: '1px solid var(--color-text-muted-purple)',
    maxHeight: '60px',
    minWidth: '120px'
  },
  lastUpdateDateSx: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-secondary)'
  },
  updateTitleBoxSx: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%'
  },
  updateBoxSx: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px'
  },
  updateBtnTextSx: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-primary)'
  },
  disUpdateBtnTextSx: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-placeholder)'
  }
};

export const keywordInfoCss = {
  mainBox: {
    display: { xs: 'grid', sm: 'flex' },
    justifyContent: 'space-between'
  },
  subBox: {
    minWidth: '60%'
  },
  keywordOverview: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-20)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-30)',
    textAlign: 'left'
  },
  subFonts: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-24)',
    textAlign: 'left',
    mt: 1
  },
  list: {
    mt: 1,
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left'
  },
  span: {
    fontWeight: 600
  },
  imgBox: {
    marginRight: 'auto',
    marginLeft: 'auto'
  }
};

export const KeywordOverviewResultCardsCss = {
  keywordSpan: {
    fontFamily: 'Inter',
    fontWeight: 700,
    color: 'var(--color-text-dark)'
  },
  keywordListBtn: {
    padding: '10px 18px 10px 18px',
    gap: '6px',
    borderRadius: '8px',
    opacity: '0px',
    minWidth: 'fit-content',
    maxHeight: '60px'
  },
  keywordListBtnText: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-primary)'
  },
  headerBox: {
    display: { xs: 'grid', sm: 'flex' },
    justifyContent: 'space-between',
    gap: '8px',
    alignItems: 'center'
  },
  mainCardsBox: {
    display: { xs: 'grid', md: 'flex' },
    justifyContent: 'space-between',
    gap: 2,
    mt: 2
  },
  subBoxes: {
    width: '100%',
    padding: '20px',
    gap: '32px',
    borderRadius: '4px',
    border: '1px solid var(--color-border)',
    opacity: '0px'
  },
  subBoxHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  helpIcon: {
    width: '20px',
    height: '20px',
    color: 'rgba(168, 166, 191, 1)',
    '&:hover': {
      color: '#120242'
    }
  },
  helpIconHead: {
    width: '16px',
    height: '16px',
    color: 'rgba(168, 166, 191, 1)',
    '&:hover': {
      color: 'var(--color-primary)'
    }
  },
  subHeaderFont: {
    fontSize: 'var(--font-size-20)',
    // fontWeight: 900,
    lineHeight: 'var(--line-height-30)',
    textAlign: 'left',
    color: 'var(--color-text-secondary)'
  },
  keywordNum: {
    fontSize: 'var(--font-size-30)',
    // fontWeight: 700,
    lineHeight: 'var(--line-height-38)',
    textAlign: 'left',
    color: 'var(--color-primary)'
  },
  keywordNumBox: {
    mt: 1
  },
  divider: {
    mt: 1,
    mb: 1
  },
  keywordDesc: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-text-secondary)'
  },
  keywordDescUrl: {
    //styleName: Text xs/Medium;
    fontFamily: 'Inter',
    fontSize: '13px',
    fontWeight: 600,
    lineHeight: 'var(--line-height-18)',
    textAlign: 'left',
    color: 'rgba(53, 16, 163, 1)',
    mt: 1,
    cursor: 'pointer'
  },
  keywordDescSpan: {
    fontWeight: 700,
    color: 'var(--color-primary)'
  },
  keywordDescSpanBlack: {
    fontWeight: 700,
    color: 'var(--color-primary)'
  },
  chip: {
    padding: '6px 16px 6px 16px',
    gap: '10px',
    borderRadius: '24px',
    opacity: '0px',
    '& .MuiChip-label': {
      fontFamily: 'Inter',
      fontSize: 'var(--font-size-16)',
      fontWeight: 500,
      lineHeight: 'var(--line-height-24)',
      textAlign: 'left'
    }
  },
  popOverBox: {
    p: 2,
    minWidth: '360px',
    maxWidth: '370px'
  },
  allLists: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-24)',
    textAlign: 'left',
    color: 'var(--color-primary)',
    marginBottom: '12px'
  },
  noList: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-text-secondary)',
    mb: 1
  },
  createNewList: {
    padding: '6px 0px 6px 0px',
    opacity: '0px',
    border: '0px',
    '&:hover': {
      border: '0px',
      backgroundColor: 'transparent'
    },
    marginTop: '16px'
  },
  createNewListText: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-purple-strong)'
  },
  fieldBtnBox: {
    marginTop: '12px',
    display: 'flex',
    justifyContent: 'space-between',
    gap: '12px'
  },
  cancelBtn: {
    padding: '8px 16px 8px 16px',
    gap: '8px',
    borderRadius: '6px',
    opacity: '0px',
    maxHeight: '40px'
  },
  cancelBtnText: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left'
  },
  colorBox: {
    display: 'flex',
    gap: '2px',
    alignItems: 'center'
  },
  colorSubBox: {
    width: 12,
    height: 12,
    borderRadius: '50%',
    marginRight: 1
  },
  reconnect: {
    borderRadius: '30px',
    padding: '6px, 16px, 6px, 16px',
    maxHeight: '32px'
  },
  intentBoxChips: {
    display: 'flex',
    gap: '2px'
  },
  rowIntent: {
    width: 30, // Square shape size
    height: 30,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 1,
    borderRadius: '4px',
    fontSize: '1rem',
    fontFamily: 'Inter',
    fontWeight: '600',
    padding: '0px, 8px, 0px, 8px'
  },
  popOverSx: {
    '& .MuiPaper-root': {
      border: '1px solid var(--color-border-muted)'
    }
  },
  addIcon: {
    color: 'var(--color-purple-strong)'
  },
  textFieldBoxSx: {
    marginTop: '20px'
  },
  backLinkBoxSx: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'space-between',
    gap: '10px',
    flexWrap: 'wrap', // allow wrapping if items overflow
    overflow: 'hidden', // optional: prevent scrollbar or hidden overflow
    maxWidth: '100%' // optional: ensure it doesn't go outside parent
  },
  viewBacklinksSx: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-14)',
    // lineHeight: 'var(--line-height-20)',
    // paddingTop: '10px',
    width: 'max-content',
    alignContent: 'end'
  }
};

export const KeywordOverviewTableCss = {
  container: {
    // mt: 4
  },
  headerFont: {
    fontSize: 'var(--font-size-18)',
    lineHeight: 'var(--line-height-28)',
    textAlign: 'left',
    color: 'var(--color-primary)',
    marginTop: '16px'
  },
  dropDownMainBox: {
    display: { xs: 'grid', md: 'flex' },
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    mt: 2,
    gap: '5px'
  },
  dropDownSubBox: {
    display: { xs: 'grid', lg: 'flex' },
    gap: 1
  },
  dropDownSelect: {
    height: '3rem',
    padding: '10px 16px 10px 16px',
    gap: '8px',
    borderRadius: '4px',
    border: '1px solid var(--color-border)',
    opacity: '0px'
  },
  selectMenuProp: {
    disableScrollLock: true // Add this line to disable scroll lock
  },
  exportBtn: {
    padding: '10px 16px 10px 16px',
    gap: '8px',
    borderRadius: '8px',
    opacity: '0px'
  },
  tableSortLabel: {
    '.MuiTableSortLabel-icon': {
      opacity: 1,
      color: 'var(--color-text-tertiary)'
    }
  },
  tableMainBox: {
    mt: 2
  },
  tableHeaderRow: {
    '& .MuiTableCell-root': {
      borderTop: 'none',
      backgroundColor: 'rgba(247, 244, 252, 1)'
    }
  },
  tableHeadText: {
    width: 'max-content',
    fontFamily: 'Inter',
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: 'var(--line-height-18)',
    textAlign: 'left',
    color: 'var(--color-text-purple)'
  },

  checkBox: {
    gap: '0px',
    borderRadius: '6px',
    padding: '0px',
    paddingLeft: '8px'
  },
  keywordCell: {
    minWidth: 150,
    textDecoration: 'underline', // Add underline on hover
    '&:hover': {
      cursor: 'pointer'
    }
  },
  keywordTextCell: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-15)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-purple-strong)'
  },
  tableCellLink: {
    fontFamily: 'Inter',
    fontSize: '13px',
    fontWeight: 500,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-primary)',
    cursor: 'pointer'
  },
  tableCellStatus: {
    fontFamily: 'Inter',
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: 'var(--line-height-18)',
    textAlign: 'left',
    color: 'var(--color-text-purple)'
  },
  tableCellText: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-15)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-text-near-black)'
  },
  tableContainer: {
    border: 'none',
    boxShadow: 'none',
    borderRadius: '2px'
  },
  relatedKeywordBtnBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    mt: 2
  },
  relatedKeywordBtnFont: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left'
  },
  noRelatedKeywords: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-18)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-24)',
    textAlign: 'center',
    color: 'rgba(16, 24, 40, 1)',
    padding: '12px'
  },
  noRelatedKeywordsKd: {
    // backgroundColor: 'rgba(247, 244, 252, 1)',
    backgroundImage: `url(${
      process.env.PUBLIC_URL + `/static/images/icons/keyword/table_blur.png`
    })`,
    // backgroundColor: 'rgba(250, 249, 251, 1)',
    padding: '34px 0px 0px 0px',
    borderRadius: '8px',
    opacity: '0px',
    mt: 1,
    height: '18rem'
  },
  noRelatedKeywordsKdn: {
    backgroundColor: 'rgba(247, 244, 252, 1)',

    // backgroundColor: 'rgba(250, 249, 251, 1)',
    padding: '0px 0px 0px 0px',
    borderRadius: '8px',
    opacity: '0px',
    mt: 1
  },
  noRelatedKeywordsDesc: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'center',
    color: 'var(--color-text-mid)',
    padding: '12px',
    paddingLeft: '45px',
    paddingRight: '45px'
  },
  numberOfKeyword: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-18)',
    textAlign: 'left',
    color: 'var(--color-text-tertiary)'
  },
  radioLabelText: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-18)',
    textAlign: 'left',
    color: 'var(--color-text-dark)'
  },
  customTextField: {
    mt: 0,
    '& fieldset': { borderRadius: '4px' }
  },
  mainExportBox: {
    maxWidth: '19rem'
  },
  rowIntent: {
    width: 20, // Square shape size
    height: 20,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 1,
    borderRadius: '4px',
    fontSize: '0.875rem'
  },
  blurBox: {
    maxWidth: '33%',
    display: 'flex',
    flexDirection: 'column',
    marginLeft: 'auto',
    marginRight: 'auto',
    padding: '24px, 48px, 24px, 48px',
    border: '1px solid var(--color-bg-muted-alt)',
    borderRadius: '12px',
    backgroundColor: 'var(--color-white)',
    mt: 2,
    mb: 2
    // boxShadow:
    //   '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 5px 8px 0px rgba(0,0,0,0.14), 0px 1px 14px 0px rgba(0,0,0,0.12)'
  },
  blurBtnBox: {
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: '0.7rem',
    marginBottom: '2rem',
    display: 'flex',
    justifyContent: 'space-between',
    gap: '16px'
  },
  blurBtn: {
    height: 'fit-content',
    width: '100%'
    // minWidth: '19rem'
  },
  blurDesc: {
    // minWidth: 'max-content',
    maxWidth: '100%',
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  blurHeaderBox: {
    display: 'flex',
    marginLeft: 'auto',
    marginRight: 'auto',
    gap: '10px',
    mt: 2
  },
  blurHeaderText: {
    fontSize: 'var(--font-size-18)',
    lineHeight: 'var(--line-height-28)',
    color: 'var(--color-primary)'
  },
  tableCellPadding: {
    paddingTop: '15px !important',
    paddingBottom: '15px !important'
  },
  gscCell: {
    textAlign: 'left',
    borderBottom: '0px'
  },
  gscImg: {
    width: '98px',
    height: '57px'
  },
  gscCellBtnBox: {
    display: 'flex'
    // gap: '8px',
    // mt: 1,
    // marginLeft: '-12%'
  },
  gscCellBtn: {
    backgroundColor: 'transparent',
    '&:hover': { backgroundColor: 'transparent' }
  },
  gscArrow: {
    width: '16px',
    height: '16px',
    marginTop: '0.88rem',
    marginLeft: '-4%'
  },
  gscCellBorder: {
    borderBottom: '0px'
  },
  gscCellBorderBox: {
    backgroundColor: 'white'
  },
  connectGscSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-18)',
    textAlign: 'center',
    color: 'var(--color-primary)'
  },
  lockIconMainBox: {
    position: 'relative',
    display: 'inline-block'
  },
  lockIconBox: {
    position: 'absolute',
    right: '6%', // Adjust this value as needed to position the image half inside and half outside
    top: '0%', // Vertically center the image
    transform: 'translateY(-50%)'
  },
  tableCellDiy: {
    padding: '0px !important'
  },
  tableCellTitle: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-primary)'
  }
};

export const commonTableHeaderIcon = {
  iconBtn: { verticalAlign: 'middle' },
  helpIcon: {
    width: '15px',
    height: '15px',
    color: 'var(--color-text-tertiary)'
  }
};

export const snackBar = {
  launchRoundedIcon: {
    verticalAlign: 'middle',
    marginLeft: '5px',
    width: '15px',
    height: '15px'
  },
  span: {
    fontWeight: 700,
    cursor: 'pointer'
  },
  alert: {
    width: '100%', // Ensure the Alert stretches to its container or specify a max-width
    maxWidth: '610px', // Example of setting a max width, adjust based on your layout needs
    backgroundColor: 'rgba(235, 255, 250, 1)', // Set the background color to red
    color: 'rgba(65, 66, 71, 1)', // Set the text color to white
    '.MuiAlert-message': {
      color: '#120242',
      fontFamily: 'Inter',
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '20px',
      textAlign: 'left'
      // wordBreak: 'break-all', // Ensures that words can be broken at any point, improving break behavior
      // whiteSpace: 'pre-wrap' // Allows text to wrap and respects newline characters in the alert message
    },
    '.MuiAlert-icon': {
      color: '#120242' // Set the alert icon color to white
    }
  },
  alertError: {
    width: '100%', // Ensure the Alert stretches to its container or specify a max-width
    maxWidth: '610px', // Example of setting a max width, adjust based on your layout needs
    backgroundColor: '#FEE4E2', // Set the background color to red
    color: 'rgba(65, 66, 71, 1)', // Set the text color to white
    '.MuiAlert-message': {
      color: '#120242',
      fontFamily: 'Inter',
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '20px',
      textAlign: 'left'
      // wordBreak: 'break-all', // Ensures that words can be broken at any point, improving break behavior
      // whiteSpace: 'pre-wrap' // Allows text to wrap and respects newline characters in the alert message
    },
    '.MuiAlert-icon': {
      color: '#B42318' // Set the alert icon color to white
    }
  }
};

export const KeywordOverviewResearchModalSxs = {
  mainBox: {
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingBottom: '24px',
    textAlign: 'center',
    maxWidth: '28rem'
  },
  headingText: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-20)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-30)',
    color: 'var(--color-primary)',
    mb: 3
  },
  desc: {
    //styleName: Text sm/Regular;
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-15)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'center',
    color: 'rgba(108, 109, 113, 1)',
    maxWidth: '20rem'
  },
  descSpan: {
    fontWeight: 600,
    color: 'var(--color-primary)'
  },
  btnBox: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '12px',
    mt: 2
  },
  btn: {
    width: '100%',
    padding: '10px 18px 10px 18px',
    borderRadius: '6px'
  }
};

export const noRelatedKeywordHelpSxs = {
  mainBox: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: '0px 0px 19px 0px',
    maxWidth: '600px'
  },
  descSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-15)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-text-input)'
  },
  btnSx: {
    marginTop: '15px',
    maxWidth: '300px',
    //marginLeft: 'auto',
    padding: '8px 18px 8px 18px'
    //marginRight: 'auto'
  },
  btnBox: {
    display: 'flex',
    gap: '8px',
    justifyContent: 'end',
    marginTop: '10px'
  },
  btnTextSx: {
    fontWeight: 500
  }
};

export const previousSearchesSx = {
  titleSx: {
    fontFamily: 'Inter',
    fontWeight: 700,
    fontSize: 'var(--font-size-30)',
    lineHeight: 'var(--line-height-38)',
    color: 'var(--color-primary)'
  },
  descSx: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-tertiary)'
  },
  previousSearchesBoxSx: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  previousTableBoxSx: {
    marginTop: '24px'
  },
  locationBoxSx: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  locationIcon: {
    borderRadius: '50%',
    width: '20px',
    height: '20px'
  },
  keywordRowText: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-purple-rich)'
  },
  dateRowText: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-primary)'
  },
  kdRowText: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-near-black)'
  }
};
